<template>
  <div class="my-4">
    <div class="flex flex-col downloadable-content my-4" ref="pdfContent" id="pdfContent">
      <div class="flex flex-col justify-center items-center space-y-2 text-gray-800">
        <div class="text-lg font-medium">
          Receipt from {{ parentEntity.persona.businessName }} ABN/ACN: {{ parentEntity.persona.abn }}
        </div>
        <div class="text-lg font-medium">
          Issued to {{ contract.businessMetaData.persona.businessName }} ABN/ACN: {{ contract.businessMetaData.persona.abn }}
        </div>
      </div>
      <div class="w-full px-4">
        <div class="text-left mx-auto max-w-[510px] mt-12">    
          
          <div class="relative overflow-x-auto">
            <table class="w-full text-sm text-left text-gray-500" id="myTable">
              <thead class="text-xs text-gray-700 uppercase bg-gray-100">
                <tr>
                  <th scope="col" class="px-6 py-3 rounded-l-lg">
                    Item
                  </th>
                  <th scope="col" class="px-6 py-3 text-center">
                    Quantity
                  </th>
                  <th scope="col" class="px-6 py-3 text-right">
                    Unit Price
                  </th>
                  <th scope="col" class="px-6 py-3 rounded-r-lg text-right">
                    Amount
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr class="bg-white" v-for="(invoice, index) in invoice.invoiceItems" :key="index">
                  <th scope="row" class="px-6 py-2 font-medium text-black font-bold whitespace-nowrap">
                    {{invoice.itemDescription}}
                  </th>
                  <td class="px-6 py-2 text-center text-gray-500 font-bold text-sm">
                    {{invoice.itemQuantity}}
                  </td>
                  <td class="px-6 py-2 text-right text-gray-500 font-bold text-sm">
                    ${{invoice.unitPrice.toFixed(2)}}
                  </td>
                  <td class="px-6 py-2 text-right text-gray-500 font-bold text-sm">
                    ${{invoice.amount.toFixed(2)}}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="flex flex-col w-full pt-10">
            <div class="pt-4 border-t">
              <div class="flex justify-between mb-4 items-center">
                <div class="font-bold text-sm text-gray-600 text-left flex-1">Subtotal</div>
                <div class="text-right w-40">
                  <div class="text-gray-500 font-bold text-sm" x-html="totalGST">${{ invoice.paymentHistory.subTotal.toFixed(2) }}</div>
                </div>
              </div>
              <div class="flex justify-between mb-4 items-center">
                <div class="font-bold text-sm text-gray-600 text-left flex-1">GST(10%)</div>
                <div class="text-right w-40">
                  <div class="text-gray-500 font-bold text-sm" x-html="totalGST">${{ invoice.paymentHistory.gstFee.toFixed(2) }}</div>
                </div>
              </div>
              <div class="flex justify-between mb-4 items-center">
                <div class="font-bold text-sm text-gray-600 text-left flex-1">Gateway Fee</div>
                <div class="text-right w-40">
                  <div class="text-gray-500 font-bold text-sm" x-html="totalGST">${{ invoice.paymentHistory.gatewayFee.toFixed(2) }}</div>
                </div>
              </div>
              <div class="flex justify-between items-center mt-4">
                <div class="text-xl font-bold text-gray-800 text-left flex-1">Total</div>
                <div class="text-right w-40">
                  <div class="text-xl text-gray-800 font-bold" x-html="netTotal">${{ invoice.paymentHistory.totalAmount.toFixed(2) }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="relative overflow-x-auto mt-4">
            <table class="w-full text-sm text-left text-gray-500">
              <thead class="text-xs text-gray-700 uppercase">
                <tr>
                  <th scope="col" class="px-6 py-1">
                    AMOUNT PAID
                  </th>
                  <th scope="col" class="px-6 py-1">
                    DATE PAID
                  </th>
                  <th scope="col" class="px-6 py-1">
                    PAYMENT METHOD
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr class="bg-white">
                  <td class="px-6 py-1 text-gray-500 text-sm">
                    ${{invoice.paymentHistory.totalAmount.toFixed(2)}}
                  </td>
                  <td class="px-6 py-1 text-gray-500 text-sm">
                    {{formatDate(invoice.paymentDate)}}
                  </td>
                  <td class="px-6 py-1 text-gray-500 text-sm">
                    <span v-if="invoice.paymentHistory.stripeCardId !== 'N/A'">
                      <font-awesome-icon :icon="paymentDetailsIcon" class="mr-1"/>-{{ paymentMethod.last4 }}
                    </span>
                    <span v-else>
                      Paid via credit.
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="flex justify-between items-center my-4">
            <div class="text-sm text-gray-500 text-left flex-1">Remarks: {{ invoice.paymentHistory.remarks }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="mt-8 flex flex-col justify-center items-center">
      <button @click.prevent="downloadPDF" class="btn btn-primary text-sm mt-5"><font-awesome-icon icon="download" class="mr-1"/>Download Receipt</button>
    </div>
  </div>
</template>
<script>
import moment from 'moment';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
export default {
  props: {
    receiptData: {
      type: Object,
      default: () => {}
    },
    entityData: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      paymentHistory: {},
      contract: {},
      parentEntity: {},
      invoice: {},
      paymentMethod: {},
      loading: false,
      paymentDetailsIcon: '',
      paymentCardLogo: ''
    }
  },

  async created() {
    this.loading = true
    this.paymentHistory = this.receiptData;
    this.contract = this.entityData.contract;
    console.log("Contract Details--", this.contract);
    if(this.contract.resellerMetaData) {
      this.parentEntity = this.contract.resellerMetaData
    } else {
      this.parentEntity = this.contract.partnerMetaData
    }
    await this.getPaymentHistoryInvoice();
  },

  methods: {
    async getPaymentHistoryInvoice() {
      await this.$store.dispatch(`billinginvoice/getInvoiceByPaymentHistory`, { contractId: this.contract._id, paymentHistory: this.paymentHistory.id })
        .then(async (response) => {
          console.log(response);
          this.invoice = response;
          if(this.invoice.paymentHistory.stripeCardId !== 'N/A') {
            await this.getPaymentMethodByCardId();  
          }
        }).finally(() => {
          this.loading = false
        })
    },

    async getPaymentMethodByCardId() {
      await this.$store.dispatch(`payment/getPaymentMethodByCardId`, this.invoice.paymentHistory.stripeCardId)
        .then((response) => {
          console.log(response);
          this.paymentMethod = response;
          if(this.paymentMethod.paymentName.toUpperCase() == 'MASTERCARD') {
              this.paymentDetailsIcon = ['fab', 'cc-mastercard']
              this.paymentCardLogo = 'data:image/png;base64,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'
          } else if(this.paymentMethod.paymentName.toUpperCase() == 'VISA') {
            this.paymentDetailsIcon = ['fab', 'cc-visa']
            this.paymentCardLogo = 'data:image/png;base64,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'
          } else {
            this.paymentDetailsIcon = 'credit-card'
          }
        })
    },

    formatDate(dateToFormat) {
      let momentDate = moment(dateToFormat);

      return momentDate.format('MMM DD,YYYY, hh:mm:ss A')
    },

    async downloadPDF() {
      // const vm = this;
      // const columns = [
      //   { title: "Item", dataKey: "itemDescription" },
      //   { title: "Quantity", dataKey: "itemQuantity" },
      //   { title: "Unit Price", dataKey: "unitPrice" },
      //   { title: "Amount", dataKey: "amount" },
      // ];
      
    
      // let opacity = 0.5;

      const doc = new jsPDF("p", "pt");
      // let bgImageWidth = 450;
      // let bgimageHeight = 450;
      // let imageX = (doc.internal.pageSize.getWidth() - bgImageWidth) / 2;
      // let imageY = (doc.internal.pageSize.getHeight() - bgimageHeight) / 2;
      // doc.setFillColor(255, 255, 255, 0.5); // Set fill color to black
      // doc.rect(0, 0, doc.internal.pageSize.width, doc.internal.pageSize.height, 'F'); // Fill the entire page
      // doc.addImage(logmasterWatermark, 'PNG', imageX, imageY - 100, bgImageWidth, bgimageHeight);
      // Set the opacity of the background image
      // doc.setFillColor(255, 255, 255, 0.5);

      // // Rect element to apply opacity to the entire image

      let receiptFrom = `From ${this.parentEntity.persona.businessName} ABN/ACN: ${this.parentEntity.persona.abn}`
      let receiptTo = `Issued to ${this.contract.businessMetaData.persona.businessName} ABN/ACN: ${this.contract.businessMetaData.persona?.abn}`
      let subTotal = `$${this.invoice.paymentHistory.subTotal.toFixed(2)}`
      let gstFee = `$${this.invoice.paymentHistory.gstFee.toFixed(2)}`
      let y = 40;
      let gatewayFee = `$${this.invoice.paymentHistory.gatewayFee.toFixed(2)}`
      let amount = `$${this.invoice.paymentHistory.totalAmount.toFixed(2)}`

      let startX = 50;
      let paymentMethod = ''
      if(this.invoice.paymentHistory.stripeCardId !== 'N/A') {
        paymentMethod = `- ${this.paymentMethod.last4}`
      } else {
        paymentMethod = 'Paid via credit card.'
      }
      //text is placed using x, y coordinates
      doc.setFont("times")
        .setFontSize(16)
        .setTextColor('#1f2938')
        .text(receiptFrom, this.alignTextCenter(doc, receiptFrom, 16), y);
      y += 25;
      doc.setFont("times")
        .setFontSize(16)
        .setTextColor('#1f2938')
        .text(receiptTo, this.alignTextCenter(doc, receiptTo, 16), y);

      y += 50;

      doc.autoTable({
        html: '#myTable',
        margin: {top: y+50}
        });
      y = doc.autoTableEndPosY()+30;
      // let rightcol1=340;
      // let rightcol2=430;
      doc.setFont("times")
        .setFontSize(12)
        .setTextColor('#1f2938')
        .text('Subtotal', this.alignTextRight(doc, subTotal, 12) - 120, y);

      doc.setFont("times")
        .setFontSize(12)
        .setTextColor('#1f2938')
        .text(subTotal, this.alignTextRight(doc, subTotal, 12), y);
      y+=18
      doc.setFont("times")
        .setFontSize(12)
        .setTextColor('#1f2938')
        .text('GST', this.alignTextRight(doc, subTotal, 12) - 120, y);
      doc.setFont("times")
        .setFontSize(12)
        .setTextColor('#1f2938')
        .text(gstFee, this.alignTextRight(doc, gstFee, 12), y);
      y+=18
      doc.setFont("times")
        .setFontSize(12)
        .setTextColor('#1f2938')
        .text('Gateway Fee', this.alignTextRight(doc, subTotal, 12) - 120, y);
      doc.setFont("times")
        .setFontSize(12)
        .setTextColor('#1f2938')
        .text(gatewayFee, this.alignTextRight(doc, gatewayFee, 12), y);
      y+=25
      doc.setFont("times")
        .setFontSize(16)
        .setTextColor('#1f2938')
        .text('Total', this.alignTextRight(doc, subTotal, 16) - 105, y);
      doc.setFont("times")
        .setFontSize(16)
        .setTextColor('#1f2938')
        .text(amount, this.alignTextRight(doc, amount, 16), y);
      y+=50
        doc.setFont("times")
          .setFontSize(10)
          .text('AMOUNT PAID', startX, y);

        doc.setFont("times")
          .setFontSize(10)
          .text(amount, startX, y+18);
        doc.setFont("times")
          .setFontSize(10)
          .text('DATE PAID', startX+200, y)

        doc.setFont("times")
          .setFontSize(10)
          .text(this.formatDate(this.invoice.paymentDate), startX+200, y+18);
        doc.setFont("times")
          .setFontSize(10)
          .text('PAYMENT METHOD', startX+400, y)
          let paymentMethodStartX = startX+400;
        if(this.invoice.paymentHistory.stripeCardId !== 'N/A') {
          doc.addImage(this.paymentCardLogo, startX+400, y+10, 15, 10)
          paymentMethodStartX = startX+420;
        }
        doc.setFont("times")
          .setFontSize(10)
          .text(paymentMethod, paymentMethodStartX, y+18);

      doc.setFont("times")
        .setFontSize(10)
        .setTextColor('#1f2938')
        .text(`Remarks: ${this.invoice.paymentHistory.remarks}`, startX, 700);
      
      doc.setLineWidth(2)
      doc.line(560, 725, 40, 725);

      

      let fileNameDate = moment(this.invoice.paymentDate).format('DD_MM_YYYY')
      doc.save(`${this.contract.businessMetaData.persona.businessName.replace(/ /g, "_")}_${fileNameDate}_receipt.pdf`);
    },

    alignTextCenter(doc, text, fontSize) {
      const width = doc.getStringUnitWidth(text) * fontSize
      const pageWidth = doc.internal.pageSize.width;
      return (pageWidth - width) / 2;
    },

    alignTextRight(doc, text, fontSize) {
      const width = doc.getStringUnitWidth(text) * fontSize
      const pageWidth = doc.internal.pageSize.width;
      return pageWidth - width - 45;
    },

    filteredInvoiceItems() {
      let items = [];
      for(const item of this.invoice.invoiceItems) {
        items.push({
          description: item.itemDescription,
          quantity: item.itemQuantity,
          unitPrice: `$${item.unitPrice.toFixed(2)}`,
          amount: `$${item.amount.toFixed(2)}`
        })
      }

      return items;
    }
  }
}
</script>